module.exports = __webpack_public_path__ + "static/media/awsLogo.b4597ef3.png";